import { render } from "./VariableFormatPanel.vue?vue&type=template&id=c377c2ec"
import script from "./VariableFormatPanel.vue?vue&type=script&lang=ts"
export * from "./VariableFormatPanel.vue?vue&type=script&lang=ts"

import "./VariableFormatPanel.vue?vue&type=style&index=0&id=c377c2ec&lang=css"
script.render = render

export default script